import React from 'react';
const LoginIcon: React.FC<{size?: number; color?: string}> = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 3H4V17H7" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
    <path d="M10 10H17" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
    <path d="M14 7L17 10L14 13" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export default LoginIcon;

